import React from 'react'

import padStart from 'lodash-es/padStart'

type Props = {
  onFinished?: () => void
  remainingSec?: (number|null)
}

type State = {
  remainingSec: number
}

const formatTime = (hours: number, minutes: number, seconds: number) =>
  padStart(hours.toString(), 2, '0')
  + ':'
  + padStart(minutes.toString(), 2, '0')
  + ':'
  + padStart(seconds.toString(), 2, '0')

class Countdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      remainingSec: props.remainingSec! | 0 // tslint:disable-line:no-bitwise
    }

    this.startCountdown()
  }

  countdownTimer?: number

  startCountdown() {
    if (this.state.remainingSec > 0) {
      this.countdownTimer = window.setTimeout(() => this.doCountdown(), 1000)
    } else if (this.props.onFinished) {
      this.props.onFinished()
    }
  }

  stopCountdown() {
    window.clearTimeout(this.countdownTimer)
    this.countdownTimer = undefined
  }

  doCountdown() {
    this.setState((state: State) => ({ remainingSec: state.remainingSec - 1 }))
    this.startCountdown()
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.remainingSec !== this.props.remainingSec) {
      this.stopCountdown()

      this.setState(
        ({ remainingSec: this.props.remainingSec! | 0 }), // tslint:disable-line:no-bitwise
        () => { this.startCountdown() },
      )
    }
  }

  componentWillUnmount() {
    this.stopCountdown()
  }

  render() {
    const { remainingSec } = this.state

    if (!remainingSec) {
      return '--:--:--'
    }

    const seconds = remainingSec % 60
    const minutes = ((remainingSec - seconds) / 60) % 60
    const hours = (remainingSec - 60 * minutes - seconds) / 3600

    return formatTime(hours, minutes, seconds)
  }
}

export default Countdown
